import { useMemo, useCallback } from "react";

import { resolveConfirmValue } from "./initialReviewConstants";

export function useReviewDecisionActions({
  formData,
  fieldDisabled,
  setFieldValue,
  handleSubmit,
  hideReferAction = false,
  hideReviseAction = false,
  onQuickStatusSubmit,
  isBusy = false,
}) {
  const confirmList = formData?.requestConfirm || [];

  const approveValue = useMemo(
    () => resolveConfirmValue(confirmList, "InProcess", "1"),
    [confirmList]
  );
  const returnValue = useMemo(
    () => resolveConfirmValue(confirmList, "ReturnToOperator"),
    [confirmList]
  );
  const reviseValue = useMemo(
    () => resolveConfirmValue(confirmList, "NotChecked", "0"),
    [confirmList]
  );
  const rejectValue = useMemo(
    () => resolveConfirmValue(confirmList, "Canceled", "2", "لغو شده"),
    [confirmList]
  );
  const followUpValue = useMemo(
    () => resolveConfirmValue(confirmList, "PendingFollowUp", "6", "نیاز به پیگیری"),
    [confirmList]
  );

  const runQuickAction = useCallback(
    (statusValue, { bypassValidation = false, notifyApplicant = false } = {}) => {
      if (!statusValue || fieldDisabled || isBusy) return;
      if (onQuickStatusSubmit) {
        onQuickStatusSubmit(statusValue, { notifyApplicant, bypassValidation });
        return;
      }
      Promise.resolve(setFieldValue("notifyApplicant", Boolean(notifyApplicant), false))
        .then(() =>
          Promise.resolve(setFieldValue("requestConfirm", statusValue, false)).then(() =>
            handleSubmit()
          )
        );
    },
    [fieldDisabled, isBusy, onQuickStatusSubmit, setFieldValue, handleSubmit]
  );

  const runSaveAction = useCallback(() => {
    if (fieldDisabled || isBusy) return;
    Promise.resolve(setFieldValue("notifyApplicant", false, false)).then(() =>
      handleSubmit()
    );
  }, [fieldDisabled, isBusy, setFieldValue, handleSubmit]);

  return {
    approveValue,
    returnValue,
    reviseValue,
    rejectValue,
    followUpValue,
    runQuickAction,
    runSaveAction,
    hideReferAction,
    hideReviseAction,
  };
}
